import { render, staticRenderFns } from "./situacia-na-vodnych-tokoch.vue?vue&type=template&id=14890f28&"
import script from "./situacia-na-vodnych-tokoch.vue?vue&type=script&lang=js&"
export * from "./situacia-na-vodnych-tokoch.vue?vue&type=script&lang=js&"
import style0 from "./situacia-na-vodnych-tokoch.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports